import SatisfiedManager from '@/assets/satisfiedManager.png';
import SatisfiedBuyer1 from '@/assets/satisfiedBuyer1.png';
import SatisfiedBuyer2 from '@/assets/satisfiedBuyer2.png';
import SatisfiedBuyer3 from '@/assets/satisfiedBuyer3.png';
import SatisfiedBuyer4 from '@/assets/satisfiedBuyer4.png';
import DissatisfiedManager from '@/assets/dissatisfiedManager.png';
import DissatisfiedBuyer1Right from '@/assets/dissatisfiedBuyer1Right.png';
import DissatisfiedBuyer2Right from '@/assets/dissatisfiedBuyer2Right.png';
import DissatisfiedBuyer3Right from '@/assets/dissatisfiedBuyer3Right.png';
import DissatisfiedBuyer4Right from '@/assets/dissatisfiedBuyer4Right.png';
import Scenario1BuyerDisabled from '@/assets/scenario1BuyerDisabled.png';
import Scenario2BuyerDisabled from '@/assets/scenario2BuyerDisabled.png';
import Scenario3BuyerDisabled from '@/assets/scenario3BuyerDisabled.png';
import Scenario4BuyerDisabled from '@/assets/scenario4BuyerDisabled.png';
import type { IGame } from '@/types/game';

const currentScenario = (scenarios: IGame[], idGame: number) =>
  scenarios.find(({ id }) => id === idGame);

const isScenarioSuccess = (scenarios: IGame[], idGame: number) =>
  currentScenario(scenarios, idGame)?.achievement;

const currentScenarioIndex = (scenarios: IGame[], idGame: number) =>
  scenarios.findIndex(({ id }) => id === idGame);

const isScenarioDisabled = (idx: number, scenarios: IGame[]) =>
  scenarios.find((_item, index) => index + 1 === idx)?.achievement === true;

const isScenarioCompleted = (idx: number, scenarios: IGame[]) =>
  scenarios.find((_item, index) => index + 1 === idx)?.status === true;

const isScenarioWithPoints = (idx: number, scenarios: IGame[]) =>
  scenarios[idx]?.isScore;

const srcManager = (idx: number, scenarios: IGame[], idGame: number) =>
  idx !== 0 && !isScenarioSuccess(scenarios, idGame)
    ? DissatisfiedManager
    : SatisfiedManager;

const srcBuyer1 = (idx: number, scenarios: IGame[], idGame: number) =>
  idx !== 0 && !isScenarioDisabled(idx, scenarios)
    ? Scenario1BuyerDisabled
    : isScenarioCompleted(idx + 1, scenarios) &&
      !isScenarioSuccess(scenarios, idGame)
    ? DissatisfiedBuyer1Right
    : SatisfiedBuyer1;

const srcBuyer2 = (idx: number, scenarios: IGame[], idGame: number) =>
  !isScenarioDisabled(idx, scenarios)
    ? Scenario2BuyerDisabled
    : isScenarioCompleted(idx + 1, scenarios) &&
      !isScenarioSuccess(scenarios, idGame)
    ? DissatisfiedBuyer2Right
    : SatisfiedBuyer2;

const srcBuyer3 = (idx: number, scenarios: IGame[], idGame: number) =>
  !isScenarioDisabled(idx, scenarios)
    ? Scenario3BuyerDisabled
    : isScenarioCompleted(idx + 1, scenarios) &&
      !isScenarioSuccess(scenarios, idGame)
    ? DissatisfiedBuyer3Right
    : SatisfiedBuyer3;

const srcBuyer4 = (idx: number, scenarios: IGame[], idGame: number) =>
  !isScenarioDisabled(idx, scenarios)
    ? Scenario4BuyerDisabled
    : isScenarioCompleted(idx + 1, scenarios) &&
      !isScenarioSuccess(scenarios, idGame)
    ? DissatisfiedBuyer4Right
    : SatisfiedBuyer4;

export const getBuyer = (scenarios: IGame[], idGame: number) =>
  !isScenarioWithPoints(currentScenarioIndex(scenarios, idGame), scenarios)
    ? srcManager(currentScenarioIndex(scenarios, idGame), scenarios, idGame)
    : (currentScenarioIndex(scenarios, idGame) +
        (!scenarios[0].isScore ? 3 : 0)) %
        4 ===
        0 || currentScenarioIndex(scenarios, idGame) === 0
    ? srcBuyer1(currentScenarioIndex(scenarios, idGame), scenarios, idGame)
    : (currentScenarioIndex(scenarios, idGame) +
        (!scenarios[0].isScore ? 2 : 3)) %
        4 ===
      0
    ? srcBuyer2(currentScenarioIndex(scenarios, idGame), scenarios, idGame)
    : (currentScenarioIndex(scenarios, idGame) +
        (!scenarios[0].isScore ? 1 : 2)) %
        4 ===
      0
    ? srcBuyer3(currentScenarioIndex(scenarios, idGame), scenarios, idGame)
    : srcBuyer4(currentScenarioIndex(scenarios, idGame), scenarios, idGame);
